// src/utils/globals.tsx
var globalVar = typeof globalThis !== "undefined" ? globalThis : typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {};
if (typeof globalThis === "undefined") {
  globalVar.globalThis = globalVar;
}
var stackGlobalsSymbol = Symbol.for("__stack-globals");
globalVar[stackGlobalsSymbol] ??= {};
function createGlobal(key, init) {
  if (!globalVar[stackGlobalsSymbol][key]) {
    globalVar[stackGlobalsSymbol][key] = init();
  }
  return globalVar[stackGlobalsSymbol][key];
}
function getGlobal(key) {
  return globalVar[stackGlobalsSymbol][key];
}
function setGlobal(key, value) {
  globalVar[stackGlobalsSymbol][key] = value;
}
export {
  createGlobal,
  getGlobal,
  globalVar,
  setGlobal
};
//# sourceMappingURL=globals.js.map